enum QBOAccountTypeEnum {
    // Asset
    BANK = "Bank",
    OTHER_CURRENT_ASSET = "Other Current Asset",
    FIXED_ASSET = "Fixed Asset",
    OTHER_ASSET = "Other Asset",
    ACCOUNTS_RECEIVABLE = "Accounts Receivable",
    // Equity
    EQUITY = "Equity",
    // Expense Accounts
    EXPENSE = "Expense",
    OTHER_EXPENSE = "Other Expense",
    COST_OF_GOOD_SOLD = "Cost of Goods Sold",
    // Liability
    ACCOUNTS_PAYABLE = "Accounts Payable",
    CREDIT_CARD = "Credit Card",
    LONG_TERM_LIABILITY = "Long Term Liability",
    OTHER_CURRENT_LIABILITY = "Other Current Liability",
    // Revenue
    INCOME = "Income",
    OTHER_INCOME = "Other Income",
}

export default QBOAccountTypeEnum;
